import React from 'react';
import { Newspaper } from 'lucide-react';

const SRC_TR = { binance: 'Binance', coinbase: 'Coinbase', upbit: 'Upbit', bithumb: 'Bithumb', okx: 'OKX', bybit: 'Bybit', coindesk: 'CoinDesk', cointelegraph: 'Cointelegraph', theblock: 'The Block', decrypt: 'Decrypt' };
const ago = (ts) => {
    const m = Math.max(0, Math.round((Date.now() / 1000 - ts) / 60));
    return m < 60 ? `${m} dk` : m < 1440 ? `${Math.round(m / 60)} sa` : `${Math.round(m / 1440)} gün`;
};

/** 📰 Haber & listeleme akışı: kaynak durumu, aktif giriş adayları, son öğeler. */
export default function NewsFeedPanel({ news, bySymbol, onSelect }) {
    if (!news) return null;
    const srcs = Object.entries(news.sources || {});
    const bad = srcs.filter(([, v]) => v.ok === false);
    return (
        <div className="rounded-lg border border-sky-500/30 bg-sky-500/5 p-3 space-y-2" data-testid="autotrade-news">
            <div className="flex flex-wrap items-center gap-2">
                <Newspaper className="h-4 w-4 text-sky-300" />
                <span className="text-xs font-bold text-slate-50">📰 Haber & Listeleme Radarı</span>
                <span className="text-[10px] text-slate-400" data-testid="autotrade-news-state">
                    {srcs.length ? `${srcs.length - bad.length}/${srcs.length} kaynak canlı · son 24 sa ${news.items_24h} coin haberi · ${news.listings_24h} listeleme` : 'ilk tarama bekleniyor'}
                </span>
                {bad.length > 0 && (
                    <span className="text-[10px] text-amber-200" data-testid="autotrade-news-bad" title={bad.map(([k, v]) => `${SRC_TR[k] || k}: ${v.error}`).join('\n')}>
                        erişilemeyen: {bad.map(([k]) => SRC_TR[k] || k).join(', ')}
                    </span>
                )}
            </div>
            {(news.entries || []).length > 0 && (
                <div className="flex flex-wrap items-center gap-1.5" data-testid="autotrade-news-entries">
                    <span className="text-[10px] font-semibold text-emerald-200">Giriş penceresi açık:</span>
                    {news.entries.map((e) => {
                        const pos = bySymbol?.[e.symbol];
                        return (
                            <button type="button" key={e.symbol} onClick={() => onSelect?.(e.symbol)} data-testid={`autotrade-news-entry-${e.symbol}`}
                                    className="text-[10px] px-1.5 py-0.5 rounded border border-emerald-500/30 bg-emerald-500/10 text-emerald-100 hover:bg-emerald-500/20">
                                {e.symbol.replace('USDT', '')} · {e.exchange || 'haber'} · {e.side === 'SHORT' ? '▼ SHORT' : '▲ LONG'} · {pos ? pos.text || pos.state : 'bot değerlendiriyor'}
                            </button>
                        );
                    })}
                </div>
            )}
            {(news.feed || []).length === 0 ? (
                <div className="text-[10px] text-slate-400" data-testid="autotrade-news-empty">Henüz coin eşleşen haber/listeleme yok — kaynaklar 90 saniyede bir taranır.</div>
            ) : (
                <div className="space-y-0.5 max-h-56 overflow-y-auto" data-testid="autotrade-news-list">
                    {news.feed.slice(0, 15).map((x) => (
                        <div key={x.id} className="flex flex-wrap items-center gap-x-2 text-[11px]" data-testid={`autotrade-news-item-${x.id}`}>
                            <span className="text-slate-500 font-mono w-12">{ago(x.ts)}</span>
                            <span className={`text-[10px] font-bold px-1 rounded ${x.kind === 'listing' ? 'bg-emerald-500/20 text-emerald-100' : x.kind === 'delisting' ? 'bg-rose-500/20 text-rose-100' : 'bg-slate-700/60 text-slate-200'}`}>{x.kind === 'listing' ? 'LİSTELEME' : x.kind === 'delisting' ? 'DELİSTE' : 'HABER'}</span>
                            <span className="text-[10px] text-sky-200">{x.exchange || SRC_TR[x.source] || x.source}</span>
                            <span className="space-x-1">
                                {(x.symbols || []).map((sy) => (
                                    <button type="button" key={sy} onClick={() => onSelect?.(`${sy}USDT`)} className="font-bold text-slate-50 hover:text-orange-200">{sy}</button>
                                ))}
                            </span>
                            <a href={x.url || '#'} target="_blank" rel="noreferrer" className="text-slate-300 hover:text-slate-100 truncate max-w-[60ch]" title={x.title}>{x.title}</a>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
